import { useEffect } from 'react'
import { useGlobalHotkeys } from '@/app/components/GlobalHotkeysProvider'

export const useFormHotkeys = (saveHandler?: () => void) => {
  const { registerSaveHandler, unregisterSaveHandler } = useGlobalHotkeys()

  useEffect(() => {
    if (saveHandler) {
      registerSaveHandler(saveHandler)
      return () => {
        unregisterSaveHandler()
      }
    }
  }, [saveHandler, registerSaveHandler, unregisterSaveHandler])
}